import SelectPure from "select-pure";

export function init(form_container) {
  form_container
    .querySelectorAll(".driftrock [data-multiselect-options]")
    .forEach((multiselect) => {
      new SelectPure(multiselect, {
        options: JSON.parse(multiselect.dataset.multiselectOptions),
        autocomplete: true,
        multiple: true,
        value: [],
        placeholder: multiselect.dataset.placeholder,
        onChange: (value) => {
          multiselect.querySelector('input[type="hidden"]').value = value;
        },
      });
    });
}
